import * as React from "react";
import { Grid } from "@material-ui/core";
import {Typography,Box} from "@mui/material";
import FilterButton from './FilterButton';
export default function ColorFilters(props) {
  return (
    <Box sx={{ width: '100%' }}>
      <FilterButton buildingId={props.buildingId} year ={props.year} getType={props.getType}/>
    </Box>
  );
}
